import http from 'plugins/axios';

export default {
  getPairList() {
    return http.get({
      url: '/la/admin/symbol/list'
    })
  },
  getRobotList(data) {
    return http.get({
      url: '/la/admin/robot/list',
      data
    })
  },
  robotAdd(data) {
    return http.post({
      url: '/la/admin/robot/add',
      data
    })
  },
  switchOff(data) {
    return http.post({
      url: '/la/admin/robot/switch-off',
      data,
      dataType: 'form'
    })
  },
  switchOn(data) {
    return http.post({
      url: '/la/admin/robot/switch-on',
      data,
      dataType: 'form'
    })
  },
  robotUpdate(data) {
    return http.post({
      url: '/la/admin/robot/update',
      data
    })
  },

};
